// extracted by mini-css-extract-plugin
export default {"btnAdd":"processorSpecific_btnAdd__XTqHy","btnRemove":"processorSpecific_btnRemove__x5ueV"};